import { Routes } from '@angular/router';
import { RenderInterfaceGuard } from 'viggo-sistemas-core-web';

export const routesAdminParametrizacao: Routes = [
  {
    path: 'pecas',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'CONFIGURACOES',
      subMenuKey: 'PRODUCAO',
      module: 'PROD_PECA',
      breadcrumb: {
        label: 'Peças',
        icon: 'pi pi-fw pi-box'
      },
      backend_path: '/pecas'
    },
    loadChildren: () =>
      import('@app/modules/pecas/pecas.module').then(m => m.PecasModule)
  },
  {
    path: 'modelos',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'CONFIGURACOES',
      subMenuKey: 'PRODUCAO',
      module: 'PROD_MODELO',
      breadcrumb: {
        label: 'Modelos',
        icon: 'pi pi-fw pi-box'
      },
      backend_path: '/modelos'
    },
    loadChildren: () =>
      import('@app/modules/modelos/modelo.module').then(m => m.ModeloModule)
  },
  {
    path: 'servicos',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'CONFIGURACOES',
      subMenuKey: 'PRODUCAO',
      module: 'PROD_SERVICO',
      breadcrumb: {
        label: 'Serviços',
        icon: 'pi pi-fw pi-wrench'
      },
      backend_path: '/servicos'
    },
    loadChildren: () =>
      import('@app/modules/servicos/servicos.module').then(
        m => m.ServicosModule
      )
  },
  {
    path: 'linha_montagem',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'CONFIGURACOES',
      subMenuKey: 'PRODUCAO',
      module: 'PROD_LINHA_PRODUCAO',
      breadcrumb: {
        label: 'Linha de montagem',
        icon: 'mdi mdi-sitemap-outline'
      },
      backend_path: '/linha_producaos'
    },
    loadChildren: () =>
      import('@app/modules/linha_producao/linha_producao.module').then(
        m => m.LinhaProducaoModule
      )
  },
  {
    path: 'etapas',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'CONFIGURACOES',
      subMenuKey: 'PRODUCAO',
      module: 'PROD_ETAPA',
      breadcrumb: {
        label: 'Etapas',
        icon: 'pi pi-fw pi-wrench'
      },
      backend_path: '/etapas'
    },
    loadChildren: () =>
      import('@app/modules/etapas/etapa.module').then(m => m.EtapaModule)
  },
  {
    path: 'processos',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'CONFIGURACOES',
      subMenuKey: 'PRODUCAO',
      module: 'PROD_PROCESSO',
      breadcrumb: {
        label: 'Processos',
        icon: 'pi pi-fw pi-wrench'
      },
      backend_path: '/processos'
    },
    loadChildren: () =>
      import('@app/modules/processos/processo.module').then(
        m => m.ProcessoModule
      )
  },
  {
    path: 'categoria_servicos',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'CONFIGURACOES',
      subMenuKey: 'PRODUCAO',
      module: 'PROD_CATEGORIA_SERVICO',
      breadcrumb: {
        label: 'Categoria de serviços',
        icon: 'mdi mdi-shape-outline'
      },
      backend_path: '/categoria_servicos'
    },
    loadChildren: () =>
      import('@app/modules/categoria-servicos/categoria_servico.module').then(
        m => m.CategoriaServicoModule
      )
  },
  {
    path: 'prioridades',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'CONFIGURACOES',
      subMenuKey: 'PRODUCAO',
      module: 'PROD_PRIORIDADE',
      breadcrumb: {
        label: 'Prioridades',
        icon: 'mdi mdi-shape-outline'
      },
      backend_path: '/prioridades'
    },
    loadChildren: () =>
      import('@app/modules/prioridades/prioridade.module').then(
        m => m.PrioridadesModule
      )
  },
  {
    path: 'niveis',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'CONFIGURACOES',
      subMenuKey: 'PRODUCAO',
      module: 'PROD_NIVEL',
      breadcrumb: {
        label: 'Níveis',
        icon: 'mdi mdi-shape-outline'
      },
      backend_path: '/niveis'
    },
    loadChildren: () =>
      import('@app/modules/niveis/nivel.module').then(m => m.NivelModule)
  },
  {
    path: 'tipo_erro_producao',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'CONFIGURACOES',
      subMenuKey: 'PRODUCAO',
      module: 'PROD_TIPO_ERRO',
      breadcrumb: {
        label: 'Tipos de erro de produção',
        icon: 'pi pi-fw pi-times-circle'
      },
      backend_path: '/tipo_erros'
    },
    loadChildren: () =>
      import('@app/modules/tipo-erro/tipo-erro.module').then(
        m => m.TipoErroProducaoModule
      )
  },
  {
    path: 'integracoes/click_massa',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'CONFIGURACOES',
      subMenuKey: 'INTEGRACOES',
      module: 'CLICK_MASSA',
    },
    loadChildren: () =>
      import('@app/modules/integracoes/click-massa/click-massa.module').then(
        m => m.ClickMassaModule
      )
  }
];
